import { render, staticRenderFns } from "./gasorder.vue?vue&type=template&id=8389559c&scoped=true"
import script from "./gasorder.vue?vue&type=script&lang=js"
export * from "./gasorder.vue?vue&type=script&lang=js"
import style0 from "./gasorder.vue?vue&type=style&index=0&id=8389559c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8389559c",
  null
  
)

export default component.exports